<template>
    <div    class=" w-full flex justify-center ">
        <div    class="w-full 2xl:w-4/5 py-8 px-8 max-w-7xl">
            <!-- User Personal Information -->
            <div>
                <div class="md:grid md:grid-cols-4 md:gap-6">
                    <div class="lg:pl-8 md:col-span-1">
                        <div class="flex flex-col items-start px-0 lg:px-4 sm:px-0">
                            <h3 class="text-lg font-medium leading-6 text-gray-900 py-0">User Information</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-600">
                                This has the user's name and the email that will be used to login.
                            </p>
                        </div>
                    </div>
                    <div class="mt-5 md:mt-0 md:col-span-3">
                        <div class="sm:overflow-hidden">
                            <user-edit-personal-information
                                    :user="user"
                                    :companyList="companyList"
                                    :isEditingSelf="isEditingSelf"
                                    v-model:save="savePersonalInformation"
                            ></user-edit-personal-information>
                        </div>
                    </div>
                </div>
            </div>

            <div class="hidden sm:block">
                <div class="py-5">
                    <div class="border-t border-gray-200"></div>
                </div>
            </div>

            <user-edit-company-information  v-model:save="saveCompanyInformation"
                                            :company-info="currentCompany"
                                            :user-id="user.id"
                                            :isEditingSelf="isEditingSelf"
                                            :un-snooze-notification-enabled="unSnoozeNotificationEnabled"
            ></user-edit-company-information>

            <!-- Save -->
            <div    v-if="canEditUser() || isEditingSelf"
                    class="flex flex-col mt-4">
                <ul class="w-full text-center">
                    <li     v-for="error in errorsWhileSavingUser"
                            class="text-red-600 py-1">
                        {{ error }}
                    </li>

                    <li     v-if="errorsWhileSavingUser.length > 0">
                        Please contact
                        <undecorated-link   :href="company.buildCompanyRoute('support')">Sonicu Support</undecorated-link>
                        if this problem persists.
                    </li>
                </ul>
                <button-blue-primary    v-if="permissions.can('update_users') || isEditingSelf"
                                        @click="saveUser"
                >
                    <div    class="w-full inline-flex justify-center">
                        <span   v-if="!isSaving">Save User</span>
                        <div    v-else  class="flex items-center">
                            <span :class="iconLoading"></span>
                            <span>Saving</span>
                        </div>
                    </div>
                </button-blue-primary>

                <!-- Revoke Access. -->
                <button-red-secondary   v-if="permissions.can('delete_users')"
                                        @click="beginRevokeAccess"
                                        class="mt-4"
                >
                    <span   v-if="!revokingAccessToUser && errorRevokingAccessToUser === null"
                    >
                        Revoke Access
                    </span>
                    <span   v-else-if="revokingAccessToUser">
                        Revoking Access To Site
                    </span>
                    <span   v-else>
                        {{ errorRevokingAccessToUser }}
                    </span>
                </button-red-secondary>
            </div>
        </div>
        <notification-modal     :is-open="isConfirmingRevokeAccess"
                                :give-option="true"
                                @action="revokeAccess"
        >
            <template   #title-content>
                <span>Confirm Revoking of Access</span>
            </template>

            <template   #button-primary-content>
                Revoke Access
            </template>

            <template   #default>
                <span>Are you sure you want to revoke access of this user to the site.</span>
            </template>
        </notification-modal>
    </div>

</template>

<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Select2 from "@/components/elements/select2"
import FloatingInput from "@/components/elements/FloatingInput";
import PermissionLevelRadio from "@/components/Users/PermissionLevelRadio";
import UserSetupNotifications from "@/components/Users/UserSetupNotifications";
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary";
import ButtonRedSecondary from "@/components/elements/buttons/ButtonRedSecondary";
import ButtonBluePrimary from "@/components/elements/buttons/ButtonBluePrimary";
import NotificationModal from "@/components/elements/NotificationModal";
import Banner from "@/components/Banners/Banner";
import BannerSuccess from "@/components/Banners/BannerSuccess";
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link";
import UserEditPersonalInformation from "@/components/Users/UserEditPersonalInformation";
import UserEditCompanyInformation from "@/components/Users/UserEditCompanyInformation";

export default {
    name: "UserSingleSiteEdit",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {
        UndecoratedLink,
        UserEditCompanyInformation,
        UserEditPersonalInformation,
        BannerSuccess,
        Banner,
        NotificationModal,
        ButtonBluePrimary,
        ButtonRedSecondary,
        ButtonBlueSecondary, UserSetupNotifications, PermissionLevelRadio, FloatingInput, Select2},
    props: {
        // User should contain name, email, company & notification info
        user: Object,
        companyList: Object,
        groupList: Object,
        permissionLevelInput: String,
        permissionsList: Array,
        currentCompany: Object,
        isEditingSelf: Boolean,
        unSnoozeNotificationEnabled: Boolean,
    },
    data() {
        return {
            // State Tracking for auxiliary actions
            savePersonalInformation: false,
            saveCompanyInformation: false,

            addingRoleToUser: false,
            errorAddingRoleToUser: null,

            errorsWhileSavingUser: [],
            revokingAccessToUser: false,
            errorRevokingAccessToUser: null,
            isConfirmingRevokeAccess: false,
            shouldActuallyRevokeAccess: false,
        }
    },
    created() {
    },
    mounted() {

    },
    methods: {
        saveUser() {
            if (!this.canEditUser() && !this.isEditingSelf) {
                return
            }
            this.savePersonalInformation = true
            this.saveCompanyInformation = true

        },
        beginRevokeAccess() {
            if (!this.permissions.can('delete_users') || this.revokingAccessToUser || this.isConfirmingRevokeAccess) {
                return
            }

            this.revokingAccessToUser = true
            this.isConfirmingRevokeAccess = true

        },
        revokeAccess(shouldRevoke) {
            this.isConfirmingRevokeAccess = false
            console.log('Should User Access.' + shouldRevoke)
            if (shouldRevoke === false) {
                this.revokingAccessToUser = false
                return
            }

            axios.delete(this.company.buildCompanyApiInternalRoute(`users/${this.user.id}`)
            ).then(response => {
                console.log('User Access Revoked')
                this.revokingAccessToUser = false
                window.location.href = this.company.buildCompanyRoute('users')
            }).catch(error => {
                this.errorRevokingAccessToUser = `An Error Occurred Revoking Access To Site`
                console.log('Failed to Revoke User\'s Access')
                console.log(error)
            }).then(() => {
                this.revokingAccessToUser = false
            })
        },
        goBack() {
          let url = this.company.buildCompanyRoute(`users`)
            if(!this.canEditUser()){  // Redirect back to this same page if we can't view the index.
              url = this.company.buildCompanyRoute(`users/${this.user.id}/edit`)
            }
            console.log(`Navigating Back to: ${url}`)
            window.location.href = url
        },
        checkInfoSaved() {
            if (!this.savePersonalInformation && !this.saveCompanyInformation) {
                this.goBack()
            }
        },
        canEditUser() {
            return this.permissions.can('update_users')
        },
    },
    computed: {
        isSaving() {
            return this.savePersonalInformation || this.saveCompanyInformation
        },
    },
    watch: {
        savePersonalInformation (value, old) {
            if (value === false && old === true) {
                this.checkInfoSaved()
            }
        },
        saveCompanyInformation (value, old) {
            if (value === false && old === true) {
                this.checkInfoSaved()
            }
        },
    },
}

</script>

<style scoped>

</style>